import { render } from "./btcCountdown.vue?vue&type=template&id=51b4dc5f"
import script from "./btcCountdown.vue?vue&type=script&lang=js"
export * from "./btcCountdown.vue?vue&type=script&lang=js"

import "./btcCountdown.vue?vue&type=style&index=0&id=51b4dc5f&lang=scss"

import exportComponent from "/home/projects/endangeredlabs-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__